import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AdminMenu from "./AdminMenu";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import ReactPaginate from "react-paginate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCode} from "@fortawesome/free-solid-svg-icons";

const AdminUserPurchases = () => {

    const [filteredPurchases, setFilteredPurchases] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 20;
    const [purchases, setPurchases] = useState([]);

    useEffect(() => {
        const fetchPurchases = async () => {
            try {
                const response = await axios.get(`${ADMIN_API_BASE}/purchase`);
                setPurchases(response.data);
                setFilteredPurchases(response.data);
            } catch (error) {
                console.error('There was a problem with the axios request:', error);
            }
        };

        fetchPurchases();
    }, []);

    useEffect(() => {
        let sortedPurchases = [...purchases];
        setFilteredPurchases(sortedPurchases);
        setCurrentPage(0); // Reset to first page on sort
    }, [purchases]);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const offset = currentPage * itemsPerPage;
    const currentPurchases = filteredPurchases.slice(offset, offset + itemsPerPage);

    return (
        <>
            <div className="flex flex-1">
                <div className="flex flex-1">
                    <div className='w-1/5'>
                        <AdminMenu path='./'/>
                    </div>
                    <div className='flex-grow w-4/5'>
                        <AdminHeader title='خرید ها'/>
                        <div className='w-full flex gap-4 py-3 px-10 flex-1 my-10'>
                            {currentPurchases.map(blog => (
                                <Link to={`/admin/purchase/${purchases.id}`} key={purchases.id} className="w-1/4">
                                    <div
                                        className="bg-white p-3 shadow-md rounded-md transition hover:bg-gray-100 hover:-translate-y-2">
                                        <h2 className="text-md line-clamp-2 mb-5">{purchases.title}</h2>
                                        <span className="text-sm text-gray-700">{purchases.updated_at}</span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                        <ReactPaginate
                            previousLabel={'قبلی'}
                            nextLabel={'بعدی'}
                            breakLabel={'...'}
                            pageCount={Math.ceil(filteredPurchases.length / itemsPerPage)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination flex justify-center mt-4'}
                            activeClassName={'active'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link p-2 border rounded mx-1'}
                            previousClassName={'page-item'}
                            previousLinkClassName={'page-link p-2 border rounded mx-1'}
                            nextClassName={'page-item'}
                            nextLinkClassName={'page-link p-2 border rounded mx-1'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link p-2 border rounded mx-1'}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminUserPurchases;
